module.exports = __webpack_public_path__ + "static/media/boutique_travel_logo.5a22317f.png";